import { connect } from 'react-redux';
import { getFieldsForType } from '../selectors/fields';
import {
    filterAdd,
    filterFieldSelected,
    filterOperatorSelected,
    filterRemove,
    filtersClear,
    filterValueAdded,
    filterValueRemoved,
    filterValuesChanged,
    setActionType,
} from '../actions/reports';
import { getAvailableFiltersForType, getCalcFilterForType } from '../selectors/reports';
import getCurrentPath from '../selectors/routing';
import { searchParamsWithReportQuery } from '../utils/url';
import FilterFields from '../components/partials/FilterFields';

const mapStateToProps = (state, ownProps) => {
    const currentPath = getCurrentPath(state);
    const isLoadedFromUrl = searchParamsWithReportQuery(currentPath.search);

    return {
        fields: getAvailableFiltersForType(ownProps.reportType)(state),
        operators: getFieldsForType('filterOperators')(state),
        filters: getCalcFilterForType(ownProps.reportType)(state),
        isLoadedFromUrl,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onFieldSelection(field, index) {
            dispatch(setActionType(filterFieldSelected(field, index), ownProps.reportType));
        },
        onOperatorSelection(field, index) {
            dispatch(setActionType(filterOperatorSelected(field, index), ownProps.reportType));
        },
        onFilterValueAdded(value, index) {
            dispatch(setActionType(filterValueAdded(value, index), ownProps.reportType));
        },
        onFilterValueRemoved(value, index) {
            dispatch(setActionType(filterValueRemoved(value, index), ownProps.reportType));
        },
        onRemoveFilter(index) {
            dispatch(setActionType(filterRemove(index), ownProps.reportType));
        },
        onAddFilter(field) {
            dispatch(setActionType(filterAdd(field), ownProps.reportType));
        },
        onFilterValuesChanged(name, values) {
            dispatch(setActionType(filterValuesChanged(name, values), ownProps.reportType));
        },
        onFilterValueChanged(value, index, name) {
            dispatch(setActionType(filterValuesChanged(name, value.trim() ? [value] : []), ownProps.reportType));
        },
        onClearFilters() {
            dispatch(setActionType(filtersClear(), ownProps.reportType));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterFields);
